import React from 'react'
import './MultiItemsGrid.css'

const MultiItemsGrid = ({children, itemsPerRow}) => {
    return (
        <div style={{gridTemplateColumns: `repeat(${itemsPerRow}, 1fr)`}} className="multi-items-grid">
            {children}
        </div>
    )
}

export default MultiItemsGrid
